import { Component, Input } from '@angular/core'

@Component({
  selector: 'atyl-container',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.scss']
})
export class ContainerComponent {

  @Input() fluid: boolean = false;
  constructor() { }

}
